import Vue from 'vue/dist/vue';

if (document.getElementById('rewards-dashboard')) {
    const rewardsDashboard = new Vue({
        el: '#rewards-dashboard',
        data: {
            member: false,
            signupSuccess: false,
            name: null,
            account: null,
            email: null,
            rewardsActive: false,
            rewardsSignup: false,
        },
        methods: {
            showSignupForm() {
                this.rewardsActive = !this.rewardsActive;
                setTimeout(() => {
                    this.rewardsSignup = !this.rewardsSignup;
                }, 100);
            },
            closeSignupForm() {
                this.rewardsSignup = !this.rewardsSignup;
                setTimeout(() => {
                    this.rewardsActive = !this.rewardsActive;
                }, 1000);
            },
            signupSuccessCheck() {
                if (this.name && this.account && this.email) {
                    this.signupSuccess = !this.signupSuccess;
                }
            },
        },
    });
}



// WEBPACK FOOTER //
// ./app/js/modules/pd-rewards.js